import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { SpaLandingPage } from './SpaLandingPage';

const mapStateToProps = (state) => ({
  spaPage: entitySelectors.getSpaPage(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  property: entitySelectors.getProperty(state),
  isSpaDaysEnabled: entitySelectors.isSpaDaysEnabled(state),
  isTreatmentEnabled: entitySelectors.isTreatmentEnabled(state),
  isFacilitiesEnabled: guestSelectors.userHasAccessToSpaEntity(state, 'facilities'),
  isClassEnabled: entitySelectors.isClassEnabled(state),
  userHasAccessToSpaClasses: guestSelectors.userHasAccessToSpaEntity(state, 'classes'),
});

export const SpaLandingPageConnected: any = connect(mapStateToProps)(SpaLandingPage);
